import { render, staticRenderFns } from "./PersonMain.vue?vue&type=template&id=7d98f79e&scoped=true&"
import script from "./PersonMain.vue?vue&type=script&lang=js&"
export * from "./PersonMain.vue?vue&type=script&lang=js&"
import style0 from "./PersonMain.vue?vue&type=style&index=0&id=7d98f79e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d98f79e",
  null
  
)

component.options.__file = "PersonMain.vue"
export default component.exports